// src/shared/api/axios.ts
import axios, { AxiosError } from 'axios'
import { AxiosError as Error } from './types'

export const $api = axios.create({
    baseURL: process.env.API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
})

$api.interceptors.response.use(
    (response) => response,
    (error: AxiosError<Error>) => {
        return Promise.reject(error)
    }
)
